export function StatePreconditionError(message, payload) {
    this.name = 'StatePreconditionError';
    this.message = message;
    this.payload = payload;
    this.upshowType = 'warning';
    this.stack = (new Error()).stack;
}

StatePreconditionError.prototype = new Error();